<template>
  <div
    :style="{'width': width + 'px', 'height': height + 'px'} "
    v-html="require(`!svg-inline-loader?idPrefix!./../../public/img/icons/${icon}.svg`)"
  />
</template>

<script>
export default {
  props: {
    icon: {
      require: true
    },
    width: {
      type: String,
      default: "24"
    },
    height: {
      type: String,
      default: "24"
    }
  }
};
</script>
